<div class="travel-container">


    <!-- Profile Info -->

    <h3 class="section-title">Profile Info</h3>

      <div class="profile-info">
       
        <img src="assets/images/employ.png" width="200px"   />
        <div class="profile-details">
          <div>Employee Name: <span>{{userInformation?.user?.name||'-'}}</span></div>
          <div>Designation: <span>{{userInformation?.userBookingProfile?.designation||'-'}}</span></div>
          <div>Employee ID: <span>{{userInformation?.userBookingProfile?.employeeCode||'-'}}</span></div>
          <div>Department: <span> {{userInformation?.userBookingProfile?.department||'-'}}</span></div>
          <div>Reporting To: <span>-</span></div>
          <div>Approver: <span>{{approver||'-'}}</span></div>
          <div>Contact No: <span>{{userInformation?.user?.mobile||'-'}}</span></div>
          <div>Email: <span>{{userInformation?.user?.email||'-'}}</span></div>

        </div>
      </div>



    <!-- Travel Details Section -->
    
    <h3 class="section-title">Travel Details</h3>

    <mat-card class="section">
      <div class="col-md-3">
        <mat-form-field  class="col-md-12" appearance="outline">
            <mat-label>Trip Name <span style="color:red">*</span></mat-label>
            <input  matInput name="name"  [(ngModel)]="travelDetails.tripName" >
          </mat-form-field>
        
      </div>
      <div class="col-md-8">
        <mat-form-field  class="col-md-12" appearance="outline">
            <mat-label>Trip Discription</mat-label>
            <textarea  matInput name="discription" id="" [(ngModel)]="travelDetails.tripDescription" cols="30" rows="1"></textarea>
          </mat-form-field>
        
      </div>
      <div class="row">
        <label class="label">Travel Type:</label>
        <mat-radio-group [(ngModel)]="travelDetails.travelType">
          <mat-radio-button class="radio-btn" color="primary" value="AD">Domestic</mat-radio-button>
          <mat-radio-button class="radio-btn" color="primary" value="AI">International</mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="row form-control">
        <label class="label">Request For:</label>
        <mat-radio-group [(ngModel)]="travelDetails.requestFor" (change)="onRequestChange()">
          <mat-radio-button class="radio-btn" color="primary" value="Self">Self</mat-radio-button>
          <mat-radio-button class="radio-btn" color="primary" value="On Behalf Of">On Behalf Of</mat-radio-button>
          <mat-radio-button class="radio-btn" color="primary" value="Other">Other (Non-Employee)</mat-radio-button>
          <button *ngIf="travelDetails.requestFor==='Other'"  class="s–button apply-button" (click)="op.toggle($event);">Passengers : {{selectedAdults}} Adult, {{selectedChildren}} Child, {{selectedInfants}} Infants </button>
          <!-- <p-button (click)="op.toggle($event)" icon="pi pi-share-alt" label="Passengers" /> -->


        </mat-radio-group>


        <span *ngIf="travelDetails.requestFor==='Other'&&otherList&&otherList.length>0" style="overflow-y: auto;" class="col-md-12">
       
          <table >
            <thead >
                <tr class="sticky-tabs">
                    <th>Type</th>
                    <th>Title</th>
                    <th>Name</th>
                    <th>Last Name</th>
                    
                    <th>Organization Name</th>
                    <th>Justification</th>
                    <th>Is Government Official</th>
                   <th></th>
                    
  
                </tr>
            </thead>
            <tbody>
              <tr *ngFor="let list of otherList;let i=index">
                <td>
                  <span>{{list.passengerType}}</span>

              </td>
                <td>
                    <mat-select class="form-control" style="width:100px;"   [(ngModel)]="list.title"  >
                      <mat-option class="mat-primary"  value="MR">Mr</mat-option>
                      <mat-option class="mat-primary" value="MRS">Mrs</mat-option>
                      <mat-option class="mat-primary" value="MS">Ms</mat-option>

                     
                    </mat-select>  
                  </td>
                <td>
                    <input class="form-control"   type="text" name="name+{{i+1}}"   [(ngModel)]="list.firstName"  >

                  
                 
                </td>
                <td>
                    <input class="form-control"   type="text" name="lastname+{{i+1}}"   [(ngModel)]="list.lastName" >
                    
                </td>
                
                <!-- <td>
                    <input class="form-control"  type="text" name="email+{{i+1}}" [(ngModel)]="list.email" >
                  </td>
                <td>
                   <input class="form-control"  type="text" name="mobile+{{i+1}}" (keypress)="onlyNumberKey($event)"   [(ngModel)]="list.mobile">
              </td> -->
              <td>
                <input class="form-control"  *ngIf="list.passengerType==='ADT'"  type="text" name="lastname+{{i+1}}"    [(ngModel)]="list.organization" >
                
            </td>
            <td>
              <input *ngIf="list.passengerType==='ADT'" class="form-control"   type="text" name="lastname+{{i+1}}"   [(ngModel)]="list.justification" >
              
          </td>
          <td>
            <input *ngIf="list.passengerType==='ADT'"    type="checkbox" style="height: 15px;width:15px" name="lastname+{{i+1}}"    [(ngModel)]="list.isGov" > <span style="font-size: 14px;"> Is Government Officer?</span>
            
        </td>
         <td>
          <img src="../../../assets/images/crosss.png" style="height: 20px;width: 20px;cursor: pointer;" (click)="cancelOtherData(i)" alt="">
          
         </td>

              </tr>
            
             
               
            </tbody>
            </table>
        </span>

        <p-overlayPanel #op>
          
            <div class="popup-container">
              <h6 style="text-align: start;" class="pt-2">ADULTS</h6>
              <div class="option-group">
                <button class="s–button" *ngFor="let num of adults" [disabled]="num===0" [class.selected]="selectedAdults === num" (click)="selectAdults(num)">{{ num }}</button>
              </div>
            
              <h6 style="text-align: start;" class="pt-2">CHILDREN</h6>
              <div class="option-group">
                <button class="s–button" *ngFor="let num of children" [class.selected]="selectedChildren === num" (click)="selectChildren(num)">{{ num }}</button>
              </div>
            
              <h6 style="text-align: start;" class="pt-2">INFANTS</h6>
              <div class="option-group">
                <button class="s–button" *ngFor="let num of infants" [class.selected]="selectedInfants === num" (click)="selectInfants(num)">{{ num }}</button>
              </div>
            
              <!-- <h3>CHOOSE TRAVEL CLASS</h3>
              <div class="class-group">
                <button *ngFor="let cls of travelClasses" [class.selected]="selectedClass === cls" (click)="selectClass(cls)">{{ cls }}</button>
              </div> -->
            <!-- <span class=" d-flex justify-content-end" style="padding-right: 20px;"><button (click)="op.hide();onClickApply()"  class="s–button apply-button">APPLY</button></span> -->
            </div>
          </p-overlayPanel>



        <mat-form-field *ngIf="travelDetails.requestFor==='On Behalf Of'"  class="col-md-4  " appearance="outline">
                                                     
          <mat-label>Traveller Name</mat-label>
          <mat-select-trigger (click)="traveller.open()">
            <input (input)="traveller.open()" matInput   placeholder="Search ..." [(ngModel)]="searchQuery" [ngModelOptions]="{standalone: true}" (ngModelChange)="filterTraveller()" />
          </mat-select-trigger>
          <mat-select multiple #traveller="matSelect"   matNativeControl name="traveller"  [(ngModel)]="onBehalf" (selectionChange)="onChangeTraveller()" >
            <mat-option *ngFor="let traveller of filteredUserGroup" [value]="traveller.userUid" >{{traveller.userBookingProfile.firstName+'-'+traveller.userBookingProfile.username}}</mat-option>
  
          </mat-select>
          </mat-form-field> 
          <span *ngIf="travelDetails.requestFor==='On Behalf Of'&&userList&&userList.length>0">
       
            <table >
              <thead >
                  <tr class="sticky-tabs">
                      <th>Title</th>
                      <th>Name</th>
    
                      <th>Last Name</th>
                      <th>Email Id</th>
    
                  </tr>
              </thead>
              <tbody>
                <tr *ngFor="let list of userList">
                  <td>{{list?.userBookingProfile?.title||'-'}}</td>
                  <td>{{list?.userBookingProfile?.firstName||'-'}}</td>
                  <td>{{list?.userBookingProfile?.lastName||'-'}}</td>
                  <td>{{list?.userBookingProfile?.username||'-'}}</td>
    
                </tr>
                 
              </tbody>
              </table>
          </span>
          <!-- <button (click)="test()">Test</button> -->
      </div>
     


        <!-- <mat-form-field  class="form-field col-md-4"  *ngIf="travelDetails.requestFor==='On Behalf Of'" appearance="outline">
            
            <mat-label>Traveller Name</mat-label>
            <mat-chip-grid #chipGrids aria-label="city Selection">
            </mat-chip-grid>
            <div class="input-with-icon col-md-12">
            <input  #travellerInput [formControl]="traveller" 
              [matChipInputFor]="chipGrids" [matAutocomplete]="autoTo"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodesTo"
              (matChipInputTokenEnd)="addTo($event)"
              />
              <mat-icon>arrow_drop_down</mat-icon>
            </div>

            <mat-autocomplete #autoTo="matAutocomplete" (optionSelected)="selectedTo($event)">
              <mat-option value="" *ngIf="usersList?.length===0">{{'Traveller Not Found'}}</mat-option>
              <mat-option  *ngFor="let item of filteredTo | async" [value]="item.username"  >
                
                {{item?.firstName}}, {{item.username}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field> -->
      <div class="row">
        <mat-form-field class="form-field" appearance="outline">
          <mat-label>Purpose</mat-label>
          <mat-select [(ngModel)]="travelDetails.purpose">
            <mat-option value="meeting">Meeting</mat-option>
            <mat-option value="conference">Conference</mat-option>
            <mat-option value="training">Training</mat-option>
            <mat-option value="others">Others</mat-option>
            <mat-option value="customer-visit">Customer Visit</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </mat-card>
  
    <!-- Itinerary Details Section -->
    <h3 class="section-title">Itinerary Details</h3>

    <mat-card class="section">
      <div class="row">
        <label class="label">Trip Type  </label>
        <mat-radio-group [(ngModel)]="itineraryDetails.tripType" (change)="onTripChange()" >
          <mat-radio-button class="radio-btn" color="primary" value="oneWay">One Way</mat-radio-button>
          <mat-radio-button class="radio-btn" color="primary" value="return">Return Trip</mat-radio-button>
          <mat-radio-button class="radio-btn" color="primary" value="multiCity">Multicity</mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="row">
        <form [formGroup]="flightSearchForm"  >
            <!-- Travelers Input -->
            <!-- <div class="form-group ">
              <label for="travelers">Number of Travelers:</label>
              <input
                id="travelers"
                type="number"
                formControlName="travelers"
                min="1"
                class="form-control"
              />
            </div> -->
        
            <!-- Dynamic Flight Segments -->
            <div formArrayName="flightSegments">
              <div
                *ngFor="let segment of flightSegments.controls; let i = index"
                [formGroupName]="i"
                class="row segment-container" 
              >
                <!-- <h3>Flight Segment {{ i + 1 }}</h3> -->
        
                <!-- From Input -->
                <div class="form-field">
                  <label for="from-{{ i }}" class="label">Origin <span style="color:red">*</span></label>
                  <input
                    id="from-{{ i }}"
                    style="font-weight:600;"
                    type="text"
                    formControlName="fromAirport"
                    placeholder="Enter departure airport code"
                    class="form-control"
                    [matAutocomplete]="fromAuto"
                  />
                  <mat-autocomplete #fromAuto="matAutocomplete" (optionSelected)="onAirportSelected($event, 'fromAirport', i)">
                    <mat-option class="mat-primary"
                      *ngFor="let airport of filteredAirports[i * 2] | async;let t=index" [ngClass]="{'odd-row': t % 2 !== 0, 'even-row': t % 2 === 0}"
                      [value]="airport.iataCode+'-'+airport.city+'-'+airport.country "
                    >
                      {{ airport.name }} ({{ airport.iataCode }}) - {{ airport.city }},
                      {{ airport.country }}
                    </mat-option>
                  </mat-autocomplete>
                </div>
        
                <!-- To Input -->
                <div class="form-field">
                  <label for="to-{{ i }}"  class="label">Destination <span style="color:red">*</span></label>
                  <input
                    id="to-{{ i }}"
                    style="font-weight:600;"
                    type="text"
                    formControlName="toAirport"
                    placeholder="Enter destination airport code"
                    class="form-control"
                    [matAutocomplete]="toAuto"
                  />
                  <mat-autocomplete #toAuto="matAutocomplete" (optionSelected)="onAirportSelected($event, 'toAirport', i)">
                    <mat-option class="mat-primary"
                      *ngFor="let airport of filteredAirports[i * 2 + 1] | async"
                      [value]="airport.iataCode+'-'+airport.city+'-'+airport.country "
                    >
                      {{ airport.name }} ({{ airport.iataCode }}) - {{ airport.city }},
                      {{ airport.country }}
                    </mat-option>
                  </mat-autocomplete>
                </div>
        
                <!-- Departure Date Input -->
                <div class="form-field ">
                    <label for="departureDate-{{ i }}" class="label">Departure Date</label>
                    <!-- <mat-hint>MM/DD/YYYY</mat-hint> -->
                    <span  class="form-control d-flex justify-content-start" style="max-height: 40px;">
                    <input   [ngxMatDatetimePicker]="picke"      style="outline:none;border:none;background-color:transparent;font-weight:600;"              
                    readonly [min]="minData" placeholder="Choose a date"   formControlName="requestedDate"
                       [disabled]="disabled">
                    <button style="margin-top: -12px;" mat-icon-button matSuffix (click)="picke.open()">
                      <mat-icon>calendar_today</mat-icon>
                    </button> 
                    <ngx-mat-datetime-picker #picke [showSpinners]="showSpinners" [showSeconds]="showSeconds"
                      [stepHour]="stepHour" [stepMinute]="stepMinute" [stepSecond]="stepSecond"
                      [touchUi]="touchUi" [color]="color" [enableMeridian]="enableMeridian" 
                      [disableMinute]="disableMinute" [hideTime]="hideTime">
                    </ngx-mat-datetime-picker>
                  </span> 
                </div>
               
                <!-- <div *ngIf="itineraryDetails.tripType!='return'" class="form-field">
                    <label for="travel_time-{{ i }}" class="label"> Preferred Time (Departure)</label>
                    <span  class="form-control d-flex justify-content-start" style="max-height: 40px;max-width: 250px;">
                      <input
                      style="font-weight: 600; outline: none; border: none; background-color: transparent; width: 180px;"
                      id="travel_time-{{ i }}"
                      [value]="timeRange[i]"
                      readonly
                      (click)="openTimePicker(i, 'from')"
                    />
                  
                    <ngx-material-timepicker-toggle
                      matSuffix
                      style="margin-top: -4px; cursor: pointer;"
                      [for]="fromPickers"
                    ></ngx-material-timepicker-toggle>
                    <ngx-material-timepicker-toggle
                    matSuffix
                    style="margin-top: -4px; cursor: pointer;"
                    [for]="toPickers"
                  >
                </ngx-material-timepicker-toggle>
                  
                    <ngx-material-timepicker #fromPickers (timeSet)="setTime($event, i, 'from',segment)" [format]="24"></ngx-material-timepicker>
                  
                    <ngx-material-timepicker #toPickers (timeSet)="setTime($event, i, 'to',segment)" [format]="24"></ngx-material-timepicker>
                
                     
              </span>
                  </div> 
                  *ngIf="itineraryDetails.tripType==='return'"
                -->
              <div  class=" d-flex justify-content-start">

                <div class="form-field " *ngIf="itineraryDetails.tripType==='return'" >
                  
                    <label for="travel_time-{{ i }}" class="label">Preferred Time (Departure)</label>
                    <span  class="form-control d-flex justify-content-start" style="max-height: 40px;">
                      <mat-select multiple formControlName="travelTime">
                        <mat-option class="mat-primary"   value="earlyMorning"  style="font-size: 12px;">Early morning  <small style="font-size: xx-small;">(Midnight - 8AM)</small></mat-option>
                         
                        <mat-option class="mat-primary"  value="morning" style="font-size: 12px;">Morning <small style="font-size: xx-small;">(8AM-Noon)</small></mat-option>
                        <mat-option class="mat-primary"  value="afternoon" style="font-size: 12px;">Afternoon <small style="font-size: xx-small;">(Noon - 4PM)</small></mat-option>
                        <mat-option class="mat-primary"  value="evening" style="font-size: 12px;">Evening <small style="font-size: xx-small;">(4PM - 8PM)</small></mat-option>
                        <mat-option class="mat-primary"  value="night" style="font-size: 12px;">Night <small style="font-size: xx-small;">(8PM - Midnight)</small></mat-option>
                
                      </mat-select>
                      <!-- <input
                      style="font-weight: 600; outline: none; border: none; background-color: transparent; width: 180px;"
                      id="travel_time-{{ i }}"
                      [value]="timeRange[i]"
                      readonly
                      (click)="openTimePicker(i, 'from')"
                    />
                  
                    <ngx-material-timepicker-toggle
                      matSuffix
                      style="margin-top: -4px; cursor: pointer;"
                      [for]="fromPickers"
                    ></ngx-material-timepicker-toggle>
                    <ngx-material-timepicker-toggle
                    matSuffix
                    style="margin-top: -4px; cursor: pointer;"
                    [for]="toPickers"
                  ></ngx-material-timepicker-toggle>
                  
                    <ngx-material-timepicker #fromPickers (timeSet)="setTime($event, i, 'from',segment)" [format]="24"></ngx-material-timepicker>
                  
                    <ngx-material-timepicker #toPickers (timeSet)="setTime($event, i, 'to',segment)" [format]="24"></ngx-material-timepicker>
                   --></span>
                  </div>
                  <div class="form-field " *ngIf="itineraryDetails.tripType!='return'" >
                  
                    <label for="travel_time-{{ i }}" class="label">Preferred Time (Departure)</label>
                   
                    <span  class="form-control d-flex justify-content-start" style="max-height: 40px;max-width: 350px;">
                      <mat-select multiple formControlName="travelTime">
                        <mat-option class="mat-primary"   value="earlyMorning"  style="font-size: 12px;">Early morning  <small style="font-size: xx-small;">(Midnight - 8AM)</small></mat-option>
                         
                        <mat-option class="mat-primary"  value="morning" style="font-size: 12px;">Morning <small style="font-size: xx-small;">(8AM-Noon)</small></mat-option>
                        <mat-option class="mat-primary"  value="afternoon" style="font-size: 12px;">Afternoon <small style="font-size: xx-small;">(Noon - 4PM)</small></mat-option>
                        <mat-option class="mat-primary"  value="evening" style="font-size: 12px;">Evening <small style="font-size: xx-small;">(4PM - 8PM)</small></mat-option>
                        <mat-option class="mat-primary"  value="night" style="font-size: 12px;">Night <small style="font-size: xx-small;">(8PM - Midnight)</small></mat-option>
                
                      </mat-select>
                      <!-- <input
                      style="font-weight: 600; outline: none; border: none; background-color: transparent; width: 180px;"
                      id="travel_time-{{ i }}"
                      [value]="timeRange[i]"
                      readonly
                      (click)="openTimePicker(i, 'from')"
                    />
                  
                    <ngx-material-timepicker-toggle
                      matSuffix
                      style="margin-top: -4px; cursor: pointer;"
                      [for]="fromPickers"
                    ></ngx-material-timepicker-toggle>
                    <ngx-material-timepicker-toggle
                    matSuffix
                    style="margin-top: -4px; cursor: pointer;"
                    [for]="toPickers"
                  ></ngx-material-timepicker-toggle>
                  
                    <ngx-material-timepicker #fromPickers (timeSet)="setTime($event, i, 'from',segment)" [format]="24"></ngx-material-timepicker>
                  
                    <ngx-material-timepicker #toPickers (timeSet)="setTime($event, i, 'to',segment)" [format]="24"></ngx-material-timepicker>
                  --> </span>
                  </div>
                  <div *ngIf="itineraryDetails.tripType==='return'" class="form-field " style="margin-left: 100px;" >
                    
                  </div>
                  <div  class="form-field" *ngIf="itineraryDetails.tripType==='return'">
                    <label for="returnDate-{{ i }}" class="label">Return Date</label>
                    <!-- <mat-hint>MM/DD/YYYY</mat-hint> -->
                    <span  class="form-control d-flex justify-content-start" style="max-height: 40px;">
                    <input   [ngxMatDatetimePicker]="returnpicke"      style="outline:none;border:none;background-color:transparent;font-weight:600;"              
                    readonly [min]="minData" placeholder="Choose a date"   formControlName="returnDate"
                       [disabled]="disabled">
                    <button style="margin-top: -12px;" mat-icon-button matSuffix (click)="returnpicke.open()">
                      <mat-icon>calendar_today</mat-icon>
                    </button> 
                    <ngx-mat-datetime-picker #returnpicke [showSpinners]="showSpinners" [showSeconds]="showSeconds"
                      [stepHour]="stepHour" [stepMinute]="stepMinute" [stepSecond]="stepSecond"
                      [touchUi]="touchUi" [color]="color" [enableMeridian]="enableMeridian" 
                      [disableMinute]="disableMinute" [hideTime]="hideTime">
                    </ngx-mat-datetime-picker>
                  </span> 
                </div>
                
                </div>
                
        
                <!-- Remove Segment Button -->
                <div class="form-group" *ngIf="itineraryDetails.tripType==='multiCity'">
                <button
                style="width: 250px;"
                  type="button"
                  (click)="removeFlightSegment(i)"
                  [disabled]="flightSegments.length === 1"
                  class="btn btn-danger "
                >
                  Remove Segment
                </button>
            </div>
              </div>
            </div>
        
            <!-- Add Segment Button -->
            <button *ngIf="itineraryDetails.tripType==='multiCity'" type="button" (click)="addFlightSegment()" class="btn btn-primary">
              Add Another Segment
            </button>
        
            <!-- Search Flights Button -->
          </form>
      </div>
      <div class="row">
        <mat-form-field class="form-field" appearance="outline">
          <mat-label>Travel Class <span style="color:red">*</span></mat-label>
         <mat-select [(ngModel)]="itineraryDetails.travelClass">
            <mat-option value="F">First</mat-option>
            <mat-option value="Y">Economy</mat-option>
            <mat-option value="W">Premium Economy</mat-option>
            <mat-option value="C">Business</mat-option>

         </mat-select>
          
        </mat-form-field>
        <mat-form-field class="form-field" appearance="outline">
            <mat-label>Cab Hire <span style="color:red">*</span></mat-label>
           <mat-select [(ngModel)]="itineraryDetails.cabHire" (selectionChange)="onChangeCabHire()">
              <mat-option value="true">Yes</mat-option>
              <mat-option value="false">No</mat-option>
             
           </mat-select>
            
          </mat-form-field>
          <mat-form-field class="form-field" appearance="outline">
            <mat-label>Accomodation  <span style="color:red">*</span></mat-label>
           <mat-select [(ngModel)]="itineraryDetails.hotelRequired"  (selectionChange)="onChangeHotelRequired()">
              <mat-option value="Self Care">Self Care</mat-option>
              <mat-option value="Admin Assistance">Admin Assistance</mat-option>
              <mat-option value="Not Required">Not Required</mat-option>


           </mat-select>
            
          </mat-form-field>
      </div>
      <!-- <div class="row" *ngIf="itineraryDetails.hotelRequired==='true'">
              <label for="location" class="label"> Hotel Location</label>

      <div class="input-group" style="width: 95%;margin: 5px;">
                <span class="input-group-addon">
                    <i class="fa fa-map-marker"></i>
                </span>
                <input style="outline: none;border: none;border-bottom: 1px solic #757575;"
                 type="text" class="form-control" placeholder="Enter location"   #addresstextInput >
            </div>
      </div> -->
      <div class="row" *ngIf="itineraryDetails.cabHire==='true'">
        <div class="col-md-12  d-flex justify-content-start">
          <!-- <mat-form-field class="col-md-4 mt-1 form-group " appearance="outline">

          </mat-form-field> -->
        <!-- <div class=" col-md-4" style="padding: 4px;">
        <label for="location" class="label">Cab Location</label>
<div class="input-group" >
          <span class="input-group-addon">
              <i class="fa fa-map-marker"></i>
          </span>
          <input class="form-control"
           type="text" class="form-control" placeholder="Enter location"   #addressCabtextInput >
      </div>
    </div> -->

    <mat-form-field class="col-md-4 mt-1 form-group " style="padding: 4px;" appearance="outline">
      
      <mat-label>Cab Location</mat-label>
      
      <div class="input-group" >
        <span class="input-group-addon">
            <i class="fa fa-map-marker"></i>
        </span>
        <input 
         type="text" matInput  placeholder="Enter location"   #addressCabtextInput >
    </div>
   </mat-form-field>
    
    <!-- <div class=" col-md-4" style="padding: 4px;">
      <label for="location" class="label">Cab Address</label>
      <div class="input-group" >
                <span class="input-group-addon">
                    <i class="fa fa-map-marker"></i>
                </span>
                <input class="form-control" [(ngModel)]="cabAddress"
                 type="text" class="form-control" placeholder="Enter Address">
            </div>
    </div> -->
    <mat-form-field class="col-md-4 mt-1 form-group " style="padding: 4px;" appearance="outline">
      <mat-label>Cab Address <span style="color:red">*</span></mat-label>

      <input   [(ngModel)]="cabAddress"
      type="text" matInput  placeholder="Enter Address">

</mat-form-field>
      <!-- <mat-form-field class="col-md-4 mt-1 form-group " appearance="outline">
      <span class="input-group-addon">
                    <i class="fa fa-map-marker"></i>
                </span>
                 <mat-label>Cab Pickup Time</mat-label>
                 <mat-hint>MM/DD/YYYY</mat-hint>
                 <input  readonly [ngxMatDatetimePicker]="pickeCab" [disabled]="disabled" [(ngModel)]="cabPickTime"
                 type="text" class="form-control"   >
                
                 <button mat-icon-button matSuffix (click)="pickeCab.open()">
                   <mat-icon>calendar_today</mat-icon>
                 </button> 
                 <ngx-mat-datetime-picker #pickeCab [showSpinners]="showSpinners" [showSeconds]="showSeconds"
                   [stepHour]="stepHour" [stepMinute]="stepMinute" [stepSecond]="stepSecond"
                   [touchUi]="touchUi" [color]="color" [enableMeridian]="enableMeridian" 
                   [disableMinute]="disableMinute" [hideTime]="hideTime">
                 </ngx-mat-datetime-picker> 
            </mat-form-field> -->

            <mat-form-field class="col-md-4 mt-1 form-group " style="padding: 4px;" appearance="outline">
              <mat-label>Cab Pickup Time <span style="color:red">*</span></mat-label>
              <!-- <mat-hint>MM/DD/YYYY</mat-hint> -->
              <input matInput  [ngxMatDatetimePicker]="picke" [min]="maxDate" readonly [(ngModel)]="cabPickTime" placeholder="Choose a date" 
                 [disabled]="disabled">
              <button mat-icon-button matSuffix (click)="picke.open()">
                <mat-icon>calendar_today</mat-icon>
              </button> 
              <ngx-mat-datetime-picker #picke [showSpinners]="showSpinners" [showSeconds]="showSeconds"
                [stepHour]="stepHour" [stepMinute]="stepMinute" [stepSecond]="stepSecond"
                [touchUi]="touchUi" [color]="color" [enableMeridian]="enableMeridian" 
                [disableMinute]="disableMinute" [hideTime]="false">
              </ngx-mat-datetime-picker> 
            </mat-form-field>
    
  </div>
</div>
    </mat-card>
  
    <!-- Upload Supporting Documents Section -->
    <h3 class="section-title">Upload Supporting Documents</h3>

    <mat-card class="section">
      <input type="file" class="file-input" (change)="onFileUpload($event)" />
      <div class="row document-list">
        <span class="no-document" *ngIf="!uploadedDocument">No Document Found</span>
        <div class="document" *ngIf="uploadedDocument">
          <span >{{ uploadedDocument.name }}</span>
          <button matSuffix mat-icon-button color="warn"  (click)="removeDocument()">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <path d="M3 6l3 18h12l3-18h-18zm16-2v-2h-4v-2h-4v2h-4v2h12z"/>
            </svg>          </button>
        </div>
      </div>
    </mat-card>
  
    <!-- Actions -->
    <!-- <div class="actions">
      <button mat-raised-button color="primary" (click)="saveAsFavourite()">Save as Favourite</button>
      <button mat-raised-button color="accent" (click)="saveAndContinue()">Save & Continue</button>
      <button mat-raised-button color="warn" (click)="saveAsDraft()">Save as Draft</button>
      <button mat-stroked-button (click)="goBack()">Back</button>
    </div> -->
    <div class="action_">

    <div class="actions">
        <!-- <button class="btn save-favourite">Save as Favourite</button> -->
        <button class="btn save-continue" (click)="searchFlights()">Save & Continue</button>
        <!-- <button class="btn save-draft">Save as Draft</button> -->
        <!-- <button class="btn back">Back</button> -->
      </div>
      </div>
      <!-- <mat-form-field appearance="outline" class="full-width">
        <mat-label>Time Range</mat-label>
        <input
          matInput
          [(ngModel)]="timeRangeDisplay"
          placeholder="hh:mm - hh:mm"
          readonly
          (click)="openTimeRangeDialog()"
        />
        <button matSuffix mat-icon-button (click)="openTimeRangeDialog()">
          <mat-icon>access_time</mat-icon>
        </button>
      </mat-form-field> 
       -->
      <!-- Dialog for Time Picker -->
       <!-- <div *ngIf="timePickerDialogVisible" class="time-range-dialog">
        <div class="dialog-content">
          <h3>Select Time Range</h3>
      
          <mat-form-field appearance="outline" class="time-field">
            <mat-label>From Time</mat-label>
            <input matInput [ngxTimepicker]="fromPicker" [(ngModel)]="fromTime" />
            <ngx-material-timepicker-toggle
              matSuffix
              [for]="fromPicker"
            ></ngx-material-timepicker-toggle>
            <ngx-material-timepicker #fromPicker></ngx-material-timepicker>
          </mat-form-field>
      
          <mat-form-field appearance="outline" class="time-field">
            <mat-label>To Time</mat-label>
            <input matInput [ngxTimepicker]="toPicker" [(ngModel)]="toTime" />
            <ngx-material-timepicker-toggle
              matSuffix
              [for]="toPicker"
            ></ngx-material-timepicker-toggle>
            <ngx-material-timepicker #toPicker></ngx-material-timepicker>
          </mat-form-field>
      
          <div class="dialog-actions">
            <button mat-button (click)="closeTimeRangeDialog()">Cancel</button>
            <button mat-raised-button color="primary" (click)="saveTimeRange()">
              Save
            </button>
          </div>
        </div>
      </div> -->
      
  </div>



 
    
   
  
  
  


  